export type BlockedTenantAction = 'block' | 'unblock';

export function resolveBlockedTenantAction({
  isTenant,
  hasManageBlockedTenantsRole,
  hasFetchedBlockedTenant,
  isTenantBlocked,
}: {
  isTenant: boolean;
  hasManageBlockedTenantsRole: boolean;
  hasFetchedBlockedTenant: boolean;
  isTenantBlocked: boolean;
}): BlockedTenantAction | null {
  if (!isTenant || !hasManageBlockedTenantsRole || !hasFetchedBlockedTenant) {
    return null;
  }

  return isTenantBlocked ? 'unblock' : 'block';
}
